/* TTW NUDGE (v28, 21 Oct 2026).
   Deal: Any 3 Thobes for $99 (Men + Kids mix, counted together), then EVERY
   extra thobe = $33 (3=$99, 4=$132, 5=$165, 6=$198). Enforced by the Shopify
   Function ttw-any3-thobes-4; this file only shows the messages.
   v27: legacy $115 mega-bundle journey is OFF (megaState() null + wipes stale flag,
   armMegaAuto() no-op, no /discount/BUNDLE115 fetch). Discount codes untouched.
   Thobe = product_type "Thobe"; father-son + Abraar uniform excluded. Kufi group unchanged. */
(function () {
  'use strict';

  var BAR = document.getElementById('ttw-bar');
  var POP = document.getElementById('ttw-pop');
  var mutedThisVisit = false;

  var GROUP_SAVE = { men: '$48', boys: '$18', kufi: '$6' };
  var MEN_URL = '/collections/men-thobes';
  var KIDS_URL = '/collections/boys-thobes-kids-islamic-clothing-usa';
  var GROUP_COLLECTION = {
    men: MEN_URL,
    boys: KIDS_URL,
    thobe: MEN_URL,
    kufi: '/collections/mens-kufi-hats-muslim-prayer-caps-topi-usa'
  };

  var POP_E = POP ? POP.querySelector('.ttw-pop-e') : null;
  var POP_H = POP ? POP.querySelector('.ttw-pop-h') : null;
  var POP_P = POP ? POP.querySelector('.ttw-pop-p') : null;
  var POP_BTNS = POP ? POP.querySelector('.ttw-pop-btns') : null;
  var POP_EXPLORE = POP ? POP.querySelector('.ttw-pop-explore') : null;
  var BAR_B = BAR ? BAR.querySelector('.ttw-bar-b') : null;
  var DEFAULT_BTNS_HTML = POP_BTNS ? POP_BTNS.innerHTML : '';
  var DEFAULT_EYEBROW = POP_E ? POP_E.textContent : 'Buy More, Save More';

  var SHOP_BTNS =
    '<a class="ttw-pop-a" href="' + MEN_URL + '">Shop Men</a>' +
    '<a class="ttw-pop-a" href="' + KIDS_URL + '">Shop Kids</a>' +
    '<a class="ttw-pop-b2 ttw-pop-bag" href="/cart">Go to bag</a>';

  function classifyThobe(item) {
    var type = String(item.product_type || '').toLowerCase();
    if (type.indexOf('thobe') === -1) return null;
    var h = String(item.handle || '').toLowerCase();
    if (h.indexOf('father') > -1) return null;
    if (h.indexOf('abraar') > -1 || h.indexOf('abrar') > -1) return null;
    return (h.indexOf('kids') > -1 || h.indexOf('boys') > -1) ? 'boys' : 'men';
  }

  function classifyKufi(item) {
    var h = String(item.handle || '').toLowerCase();
    if (h.indexOf('abraar') > -1 || h.indexOf('abrar') > -1) return false;
    var type = String(item.product_type || '').toLowerCase();
    if (type.indexOf('topi') > -1 || type.indexOf('kufi') > -1) return true;
    if (h.indexOf('kufi') > -1 || h.indexOf('topi') > -1) return true;
    var tagStr = '';
    try {
      var tags = item.tags;
      tagStr = (Array.isArray(tags) ? tags.join(' ') : String(tags || '')).toLowerCase();
    } catch (e) {}
    return tagStr.indexOf('kufi') > -1 || tagStr.indexOf('topi') > -1;
  }

  function keepShoppingUrl(group) {
    var path = '';
    try { path = window.location.pathname || ''; } catch (e) {}
    if (path.indexOf('/collections/') === 0) {
      return path + (window.location.search || '');
    }
    return GROUP_COLLECTION[group] || GROUP_COLLECTION.men;
  }

  function markJustAdded() {
    try { sessionStorage.setItem('ttwJustAdded', '1'); } catch (e) {}
  }

  function closeNativeOverlays() {
    try {
      var openPopups = document.querySelectorAll('.cc-popup[aria-hidden="false"]');
      Array.prototype.forEach.call(openPopups, function (p) {
        if (p.id === 'ttw-pop' || (POP && p === POP)) return;
        var closeBtn = p.querySelector('.cc-popup-close');
        if (closeBtn) { closeBtn.click(); return; }
        p.setAttribute('aria-hidden', 'true');
      });
    } catch (e) {}
  }

  function paintBar(group, count, justIncreased) {
    if (!BAR || mutedThisVisit) return;
    if (count < 1) {
      BAR.hidden = true;
      document.body.classList.remove('ttw-bar-on');
      return;
    }
    var textEl = BAR.querySelector('.ttw-bar-t');
    if (group === 'kufi') {
      if (count === 1) {
        textEl.innerHTML = '<b>1 kufi</b> in your bag &nbsp;&middot;&nbsp; add 2 more and pay <b>$45 for 3</b>';
      } else if (count === 2) {
        textEl.innerHTML = '<b>2 kufis</b> in your bag &nbsp;&middot;&nbsp; add 1 more and pay <b>$45 for 3</b> &mdash; save ' + GROUP_SAVE.kufi;
      } else {
        textEl.innerHTML = '&#127881; <b>3 for $45</b> unlocked &mdash; plus <b>$15 each</b> after that!';
      }
    } else {
      var n = count + (count === 1 ? ' thobe' : ' thobes');
      if (count === 1) {
        textEl.innerHTML = '<b>' + n + '</b> in your bag &nbsp;&middot;&nbsp; add 2 more (men + kids mix) &mdash; <b>any 3 for $99</b>';
      } else if (count === 2) {
        textEl.innerHTML = '<b>' + n + '</b> in your bag &nbsp;&middot;&nbsp; add <b>1 more</b> &mdash; <b>any 3 for $99</b> (men + kids mix)';
      } else if (count === 3) {
        textEl.innerHTML = '&#127881; <b>Deal unlocked</b> &mdash; any 3 thobes for <b>$99</b> &nbsp;&middot;&nbsp; every extra thobe just <b>$33</b>';
      } else {
        textEl.innerHTML = '<b>' + n + '</b> in your bag &nbsp;&middot;&nbsp; first 3 for <b>$99</b> + <b>' + (count - 3) + ' extra at $33 each</b>';
      }
    }
    if (BAR_B) BAR_B.href = GROUP_COLLECTION[group] || GROUP_COLLECTION.men;
    BAR.hidden = false;
    document.body.classList.add('ttw-bar-on');

    if (justIncreased) {
      BAR.classList.remove('ttw-bar-blink');
      void BAR.offsetWidth;
      BAR.classList.add('ttw-bar-blink');
      window.clearTimeout(paintBar._t);
      paintBar._t = window.setTimeout(function () {
        BAR.classList.remove('ttw-bar-blink');
      }, 1900);
    }
  }

  function drawerLine(group, count) {
    var d = document.querySelector('.cart-drawer, [class*="cart-drawer"]');
    if (!d) return;
    var old = d.querySelector('.ttw-drawer-line');
    if (old) old.parentNode.removeChild(old);
  }

  function resetPopChrome() {
    if (!POP) return;
    POP.classList.remove('ttw-pop--celebrate');
    POP.classList.remove('ttw-pop--mega');
    if (POP_E) POP_E.textContent = DEFAULT_EYEBROW;
    if (POP_BTNS) POP_BTNS.innerHTML = DEFAULT_BTNS_HTML;
    if (POP_EXPLORE) POP_EXPLORE.innerHTML = '';
    var old = POP.querySelector('.ttw-confetti');
    if (old) old.parentNode.removeChild(old);
  }

  function alreadyShowing(stateKey) {
    return !!(POP && !POP.hidden && POP.getAttribute('data-ttw-state') === stateKey);
  }
  function markShowing(stateKey) {
    if (POP) POP.setAttribute('data-ttw-state', stateKey);
  }

  function showPop(group, count) {
    if (!POP) return;
    var stateKey = 'pop:' + group + ':' + count;
    if (alreadyShowing(stateKey)) return;
    markShowing(stateKey);

    closeNativeOverlays();
    resetPopChrome();

    if (group === 'kufi') {
      var needK = 3 - count;
      if (POP_H) POP_H.innerHTML = 'You are <span class="ttw-hi">' + needK + ' kufi' + (needK > 1 ? 's' : '') + '</span> away from the deal';
      if (POP_P) POP_P.innerHTML = 'Add ' + needK + ' more and pay <b>$45 for 3</b> instead of full price &mdash; you save ' +
                    GROUP_SAVE.kufi + '. Applied automatically at checkout, no code needed.';
      if (POP_BTNS) {
        POP_BTNS.innerHTML =
          '<a class="ttw-pop-a" href="' + GROUP_COLLECTION.kufi + '">Add more kufis</a>' +
          '<a class="ttw-pop-b2" href="/cart">Go to bag</a>';
      }
    } else {
      var need = 3 - count;
      if (POP_E) POP_E.textContent = 'Any 3 Thobes for $99';
      if (need === 1) {
        if (POP_H) POP_H.innerHTML = 'Just <span class="ttw-hi">1 more thobe</span> for $99';
      } else {
        if (POP_H) POP_H.innerHTML = 'Add <span class="ttw-hi">2 more</span> &mdash; any 3 thobes for $99';
      }
      if (POP_P) POP_P.innerHTML = 'Mix <b>men &amp; kids</b> thobes any way you like. Add ' + need + ' more and pay <b>$99 for 3</b> instead of full price. After that, every extra thobe is just <b>$33</b>. Applied automatically at checkout, no code needed.';
      if (POP_BTNS) POP_BTNS.innerHTML = SHOP_BTNS;
    }

    POP.hidden = false;
    document.body.classList.add('ttw-pop-on');
  }

  function confetti() {
    if (!POP) return;
    var wrap = document.createElement('div');
    wrap.className = 'ttw-confetti';
    var colors = ['#A21B3D', '#EC8DA5', '#F4F1ED', '#DFD9D2'];
    for (var i = 0; i < 28; i++) {
      var s = document.createElement('span');
      s.style.left = (Math.random() * 100) + '%';
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = (Math.random() * 0.5) + 's';
      s.style.transform = 'rotate(' + Math.round(Math.random() * 360) + 'deg)';
      wrap.appendChild(s);
    }
    POP.appendChild(wrap);
  }

  function showCelebrate(group, count) {
    if (!POP) return;
    var stateKey = 'celebrate:' + group + ':' + count;
    if (alreadyShowing(stateKey)) return;
    markShowing(stateKey);

    closeNativeOverlays();
    resetPopChrome();
    POP.classList.add('ttw-pop--celebrate');

    var bundles = Math.floor(count / 3);
    if (POP_E) POP_E.textContent = 'Buy More, Save More';
    if (group === 'kufi') {
      if (POP_H) POP_H.innerHTML = '🎉 3 for $45 is yours!';
      if (POP_P) {
        POP_P.innerHTML = bundles > 1
          ? 'You have unlocked <b>' + bundles + ' bundles</b> of 3 &mdash; nice work! Every kufi is just <b>$15</b>, applied automatically at checkout.'
          : 'Nice work &mdash; <b>$45 for 3</b>, and every kufi after that is just <b>$15</b>. Applied automatically at checkout, no code needed.';
      }
    } else {
      if (POP_H) POP_H.innerHTML = '🎉 Deal unlocked: 3 thobes for $99';
      if (POP_P) POP_P.innerHTML = 'Any 3 thobes (men + kids mix) for <b>$99</b> &mdash; applied automatically at checkout, no code needed. Add more and every extra thobe is just <b>$33</b>.';
    }
    if (POP_BTNS) {
      POP_BTNS.innerHTML = group === 'kufi'
        ? '<a class="ttw-pop-a" href="/cart">Go to bag</a><a class="ttw-pop-b2" href="' + keepShoppingUrl(group) + '">Keep shopping</a>'
        : SHOP_BTNS;
    }
    confetti();

    POP.hidden = false;
    document.body.classList.add('ttw-pop-on');
  }

  function showUpsell(group, count) {
    if (!POP) return;
    var stateKey = 'upsell:' + group + ':' + count;
    if (alreadyShowing(stateKey)) return;
    markShowing(stateKey);

    closeNativeOverlays();
    resetPopChrome();
    POP.classList.add('ttw-pop--celebrate');

    var toNext = 3 - (count % 3);
    if (POP_E) POP_E.textContent = 'Buy More, Save More';
    if (group === 'kufi') {
      if (POP_H) POP_H.innerHTML = 'Nice, ' + count + ' kufis in your bag!';
      if (POP_P) {
        POP_P.innerHTML = 'Every kufi past your first 3 is already just <b>$15</b> &mdash; add <b>' + toNext +
          ' more</b> for your next $45 bundle.';
      }
    } else {
      if (POP_H) POP_H.innerHTML = 'Nice, ' + count + ' thobes in your bag!';
      if (POP_P) {
        POP_P.innerHTML = 'Your first <b>3</b> thobes are <b>$99</b> and your <b>' + (count - 3) +
          ' extra</b> ' + (count - 3 === 1 ? 'thobe is' : 'thobes are') + ' just <b>$33 each</b> &mdash; add as many as you like (men + kids mix).';
      }
    }
    if (POP_BTNS) {
      POP_BTNS.innerHTML = group === 'kufi'
        ? '<a class="ttw-pop-a" href="/cart">Go to bag</a><a class="ttw-pop-b2" href="' + keepShoppingUrl(group) + '">Keep shopping</a>'
        : SHOP_BTNS;
    }
    if (POP_EXPLORE) {
      if (group === 'kufi') {
        POP_EXPLORE.innerHTML =
          '<p class="ttw-pop-explore-h">Explore More</p>' +
          '<div class="ttw-pop-explore-grid">' +
            '<a href="/collections/men-thobes">Men&#39;s Thobes</a>' +
            '<a href="/collections/boys-thobes-kids-islamic-clothing-usa">Boys&#39; Thobes</a>' +
            '<a href="/collections/father-son-matching-thobes-sets-usa">Father &amp; Son Sets</a>' +
            '<a href="/collections/pants-trouser">Pants &amp; Trousers</a>' +
          '</div>';
      } else {
        POP_EXPLORE.innerHTML =
          '<p class="ttw-pop-explore-h">Explore More</p>' +
          '<div class="ttw-pop-explore-grid">' +
            '<a href="/collections/mens-kufi-hats-muslim-prayer-caps-topi-usa">Kufi Caps</a>' +
            '<a href="/collections/father-son-matching-thobes-sets-usa">Father &amp; Son Sets</a>' +
            '<a href="/collections/pants-trouser">Pants &amp; Trousers</a>' +
          '</div>';
      }
    }

    POP.hidden = false;
    document.body.classList.add('ttw-pop-on');
  }

  function showEncourage() {
    if (!POP) return;
    closeNativeOverlays();
    resetPopChrome();

    if (POP_E) POP_E.textContent = 'Keep Going!';
    if (POP_H) POP_H.innerHTML = 'Nice pick! &#127881;';
    if (POP_P) {
      POP_P.innerHTML = 'The more you add to your bag, the more you save &mdash; ' +
        'mix and match thobes, kufis and more to unlock bigger bundle savings.';
    }
    if (POP_BTNS) {
      POP_BTNS.innerHTML =
        '<a class="ttw-pop-a" href="/cart">Go to bag</a>' +
        '<a class="ttw-pop-b2" href="/collections/all">Keep shopping</a>';
    }

    markShowing('encourage:' + POP_H.innerHTML.length + ':' + Math.random());
    POP.hidden = false;
    document.body.classList.add('ttw-pop-on');
  }

  function hidePop() {
    if (!POP) return;
    POP.hidden = true;
    POP.removeAttribute('data-ttw-state');
    document.body.classList.remove('ttw-pop-on');
    closeNativeOverlays();
  }

  if (POP) {
    POP.addEventListener('click', function (e) {
      if (e.target.closest('.ttw-pop-x') || e.target.classList.contains('ttw-pop-bg')) hidePop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePop();
    });
  }

  var MEGA_KEY = 'ttwMegaBundle';

  /* v27: legacy $115 mega-bundle journey is OFF. */
  function megaState() {
    try { localStorage.removeItem(MEGA_KEY); } catch (e) {}
    return null;
  }

  function armMegaAuto(group, count) {
    return;
  }

  var first = true;
  var lastMen = null;
  var lastBoys = null;
  var lastKufi = null;

  function readCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var men = 0, boys = 0, kufi = 0;
        (c.items || []).forEach(function (i) {
          var g = classifyThobe(i);
          if (g === 'men') { men += i.quantity; return; }
          if (g === 'boys') { boys += i.quantity; return; }
          if (classifyKufi(i)) kufi += i.quantity;
        });
        var thobe = men + boys;

        var justAdded = false;
        var justAddedGroup = null;
        var hasPreciseGroup = false;
        try {
          if (sessionStorage.getItem('ttwJustAdded') === '1') {
            justAdded = true;
            sessionStorage.removeItem('ttwJustAdded');
          }
          var storedGroup = sessionStorage.getItem('ttwJustAddedGroup');
          if (storedGroup !== null) {
            hasPreciseGroup = true;
            justAddedGroup = storedGroup || null;
            sessionStorage.removeItem('ttwJustAddedGroup');
          }
        } catch (e) {}

        var menIncreased = !first && lastMen !== null && men > lastMen;
        var boysIncreased = !first && lastBoys !== null && boys > lastBoys;
        var kufiIncreased = !first && lastKufi !== null && kufi > lastKufi;

        var addGroup = null;
        if (boysIncreased) addGroup = 'boys';
        else if (menIncreased) addGroup = 'men';
        else if (kufiIncreased) addGroup = 'kufi';
        else if (hasPreciseGroup) {
          addGroup = justAddedGroup;
        } else if (justAdded && first) {
          if (boys > 0) addGroup = 'boys';
          else if (men > 0) addGroup = 'men';
          else if (kufi > 0) addGroup = 'kufi';
        }

        function countFor(g) {
          if (g === 'thobe') return thobe;
          if (g === 'boys') return boys;
          if (g === 'kufi') return kufi;
          return men;
        }
        function popGroupOf(g) {
          return (g === 'men' || g === 'boys') ? 'thobe' : g;
        }

        var popGroup = popGroupOf(addGroup);
        var displayGroup = thobe > 0 ? 'thobe' : (kufi > 0 ? 'kufi' : null);
        if (popGroup) displayGroup = popGroup;

        if (displayGroup) {
          paintBar(displayGroup, countFor(displayGroup), !!addGroup);
          drawerLine(displayGroup, countFor(displayGroup));
        } else {
          paintBar('thobe', 0, false);
          drawerLine('thobe', 0);
        }

        lastMen = men;
        lastBoys = boys;
        lastKufi = kufi;

        armMegaAuto(addGroup, addGroup ? countFor(addGroup) : 0);
        megaState();

        if (addGroup) {
          var count = countFor(popGroup);
          if (popGroup === 'thobe') {
            if (count === 3) {
              showCelebrate('thobe', count);
            } else if (count > 3) {
              showUpsell('thobe', count);
            } else if (count >= 1) {
              showPop('thobe', count);
            }
          } else if (count >= 1 && count < 3) {
            showPop(popGroup, count);
          } else if (count >= 3 && count % 3 === 0) {
            showCelebrate(popGroup, count);
          } else if (count > 3) {
            showUpsell(popGroup, count);
          }
        } else if (!first && men === 0 && boys === 0 && kufi === 0) {
          hidePop();
        }

        first = false;
      })
      .catch(function () { first = false; });
  }

  readCart();

  setInterval(readCart, 1200);

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var p = _fetch.apply(this, args);
    try {
      var u = (args[0] && args[0].url) || args[0] || '';
      if (typeof u === 'string' && u.indexOf('/cart/add') > -1) {
        markJustAdded();
        p.then(function (res) {
          try {
            res.clone().json().then(function (data) {
              var items = (data && Array.isArray(data.items)) ? data.items : (data ? [data] : []);
              var thobeG = null;
              var hasKufi = false;
              items.forEach(function (it) {
                var cg = classifyThobe(it);
                if (cg === 'boys') thobeG = 'boys';
                else if (cg === 'men' && thobeG !== 'boys') thobeG = 'men';
                else if (!cg && classifyKufi(it)) hasKufi = true;
              });
              var g = thobeG || (hasKufi ? 'kufi' : null);
              try { sessionStorage.setItem('ttwJustAddedGroup', g || ''); } catch (e2) {}
              if (!g) showEncourage();
            }).catch(function () {});
          } catch (e3) {}
          setTimeout(readCart, 450);
        });
      } else if (typeof u === 'string' &&
          (u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1)) {
        p.then(function () { setTimeout(readCart, 450); });
      }
    } catch (e) {}
    return p;
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[name="add"], form[action*="/cart/add"] button')) {
      markJustAdded();
      setTimeout(readCart, 1000);
    }
  });

  var close = document.getElementById('ttw-bar-x');
  if (close) {
    close.addEventListener('click', function () {
      mutedThisVisit = true;
      BAR.hidden = true;
      document.body.classList.remove('ttw-bar-on');
    });
  }

  if (!window.TTW_STOCK) return;

  var LOW = 5;
  var lastShown = null;

  function currentVariant() {
    var v = null;
    try { v = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
    return v || window.TTW_FIRST_VARIANT || '';
  }

  function stock() {
    var q = window.TTW_STOCK[currentVariant()];
    var el = document.getElementById('ttw-stock');

    if (!el) {
      var anchor = document.querySelector('.quantity-submit-row') ||
                   document.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (!anchor) return;
      el = document.createElement('div');
      el.id = 'ttw-stock';
      anchor.parentNode.insertBefore(el, anchor);
    }

    if (typeof q === 'number' && q > 0 && q <= LOW) {
      if (lastShown !== q) { el.textContent = 'Only ' + q + ' left in this size'; lastShown = q; }
      el.hidden = false;
    } else {
      el.hidden = true;
      lastShown = null;
    }
  }

  stock();
  setInterval(stock, 700);
})();
